import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Verified Credentials & LinkedIn Sharing',
    title: 'Let candidates showcase verified skills on LinkedIn',
    subtitle: 'Every CHIRE credential is a public, tamper-proof record of a candidate\u2019s screening, assessment, interview, and verification results \u2014 shareable in one click and addable directly to a LinkedIn profile.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #1B3A6B 50%, #0A66C2 100%)',
  },
  sections: [
    {
      label: 'Shareable & Verifiable',
      title: 'A credential candidates are proud to share',
      features: [
        { icon: '\ud83d\udd17', title: 'Add to LinkedIn', desc: 'One click opens LinkedIn\u2019s certification flow pre-filled with the credential name, CHIRE as issuer, issue date, and a verification URL.' },
        { icon: '\ud83d\udce3', title: 'Share to Feed', desc: 'Candidates share their verified credential as a LinkedIn post, driving organic visibility back to your brand and the candidate\u2019s achievement.' },
        { icon: '\ud83c\udf10', title: 'Public Verification Page', desc: 'A clean, no-login verification page shows scores, on-chain proof, and readiness level \u2014 any recruiter can confirm authenticity instantly.' },
        { icon: '\ud83d\udcca', title: 'Full Score Report', desc: 'Screening fit, assessment skill breakdown, interview ratings, and background-verification status \u2014 all on one shareable card.' },
        { icon: '\u26d3\ufe0f', title: 'On-Chain Anchoring', desc: 'Each credential is anchored with a transaction hash and block number, making the record tamper-proof and trustworthy.' },
        { icon: '\ud83c\udfc6', title: 'Readiness Badges', desc: 'Fully Verified, Partially Verified, or Initial badges give recruiters instant confidence in a candidate\u2019s validated stages.' },
      ],
      columns: 3,
    },
    {
      label: 'Why It Matters',
      title: 'Turn evaluations into a viral growth loop',
      desc: 'When candidates share verified credentials on LinkedIn, your platform gets free, trusted exposure \u2014 and verified candidates attract recruiters without re-screening.',
      bullets: [
        'Candidates proudly broadcast verified results to their network',
        'Each shared link routes recruiters back to CHIRE',
        'Verified candidates skip redundant re-screening elsewhere',
        'Issuer attribution puts your brand on every LinkedIn profile',
        'Copy-link option for email, portfolios, and applications',
      ],
      visual: '\ud83d\udcbc',
      visualLabel: 'LinkedIn Credential Share',
    },
    {
      label: 'For Candidates',
      title: 'Own and showcase your verified record',
      desc: 'Your credential is yours to keep and share anywhere. It proves your skills and authenticity to any employer \u2014 no need to repeat assessments.',
      bullets: [
        'Add the credential to your LinkedIn certifications in one tap',
        'Share a public verification link with any recruiter',
        'AI integrity scoring proves the results are genuinely yours',
        'View all your credentials from the Candidate Portal',
      ],
      visual: '\ud83d\udcf1',
      visualLabel: 'Candidate Credential Wallet',
    },
  ],
  testimonial: {
    quote: 'Candidates love adding their CHIRE credential to LinkedIn \u2014 and every share sends qualified recruiters straight to us. It\u2019s become one of our best top-of-funnel channels.',
    name: 'Grace T.',
    role: 'Growth Lead, TalentBridge',
  },
  cta: {
    title: 'Give candidates a credential worth sharing',
    desc: 'Verified, LinkedIn-ready credentials that build trust and visibility. Get started with CHIRE.',
  },
};

export default function VerifiedCredentialsPage() { return <ProductPageTemplate data={DATA} />; }
